// removed by extract-text-webpack-plugin
module.exports = {"HeaderImage":"src-components-Header----HeaderImage-module---HeaderImage---16U8k","overlayContainer":"src-components-Header----HeaderImage-module---overlayContainer---1qdvt","overlay":"src-components-Header----HeaderImage-module---overlay---18FHp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/HeaderImage.module.css
// module id = 381
// module chunks = 114276838955818